<template>
  <!-- div class="centerbox">
    <p v-if="outcome === 'Correct'" :class="{ success: outcome === 'Correct', failure: outcome === 'Incorrect', centerText: true }">
      <center>+1 point</center>
    </p>
    <p v-else-if="outcome === 'Respond Faster'" :class="{ success: outcome === 'Correct', failure: outcome === 'Respond Faster', centerText: true }">
      <center>Respond Faster</center>
   </p>
    <p v-else :class="{ success: outcome === 'Correct', failure: outcome === 'Incorrect', centerText: true }">
      <center>+0 point</center>
   </p>
    
  </div -->
  <div>

    <div class="centerbox">
    <b-alert variant="warning" :show ="outcome === 'Correct'" class='centerOutcome col text-center'>+ 1 point</b-alert>
    <b-alert variant="primary" :show ="outcome === 'Respond Faster'" class='centerOutcome col text-center'>Respond Faster</b-alert>
    <b-alert variant="primary" :show ="outcome === 'Incorrect'" class='centerOutcome col text-center'>+ 0 points</b-alert>
    </div>

    <!-- div style = "display: none">
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue1']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue2']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue3']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue4']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue5']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue6']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue7']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialCues['cue8']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe1']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe2']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe3']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe4']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe5']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe6']"/>
      <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe7']"/>
    </div -->


  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import State from '../mixins/State'
export default {
  mixins: [ State ],
  data: () => {
    return {
      timer: undefined,
      start_time: undefined,
      end_time: undefined
    }
  },
  computed: {
    ...mapGetters(['getCorrectAudio', 'getIncorrectAudio', 'getNoResponseAudio']),
    ...mapState(['outcome', 'trial', 'blocksCompleted']),
    ...mapState({
      outcome_duration: state => state.parameters.outcome_duration,
      blocks: state => state.parameters.blocks
    })
  },
  mounted () {
    this.start_time = Date.now()
    // creates a timer for navigation to the next state
    var audio
    if (this.outcome === 'Correct') {
      audio = new Audio(this.getCorrectAudio)
    } else if (this.outcome === 'Incorrect') {
      audio = new Audio(this.getIncorrectAudio)
    } else {
      audio = new Audio(this.getNoResponseAudio)
    }
    audio.play()
    this.timer = setTimeout(() => {
      if (this.trial) { // if trial was set, go to the focus state
        this.$router.replace('/focus/outcome')
      } else { // else if there are no more trials
        this.nextBlock() // go to the next block
        if (this.blocksCompleted >= this.blocks) {
          // if all blocks are now completed, go to complete state
          this.end()
          this.$router.replace('/complete')
        } else {
          // if more blocks, go the next block state
          this.$router.replace('/block')
        }
      }
    }, this.outcome_duration)
  },
  beforeDestroy () {
    // clear timer when leaving the outcome state
    clearTimeout(this.timer)
    this.end_time = Date.now()
    this.response({ r: null, start_time: this.start_time, end_time: this.end_time, response_state: 'outcome' })
  },
  methods: {
    ...mapActions(['nextBlock', 'response'])
  }
}
</script>

<style scoped>
  .container {
    height: 50vh;
    width: 50vh;
  }
  .success {
    color: #cce5ff; /*green;*/
  }
  .failure {
    color: #fff3cd; /*red;*/
  }
</style>
